'use strict';
import React, { PureComponent } from 'react';
import SeccionSuperior from './SeccionSuperior';
import SeccionRecontabilizacion from './SeccionRecontabilizacion';
import SeccionProcesos from './SeccionProcesos/SeccionProcesos';
import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';

/* MODALES */
import ModalProceso from './Modales/ModalProceso/ModalProceso';
import ModalSeleccionModelos from './Modales/ModalSeleccionModelos/ModalSeleccionModelos';
import ModalConfirmacionEjecucion from './Modales/ModalConfirmacionEjecucion/ModalConfirmacionEjecucion';
import ModalInformarProximoPaso from './Modales/ModalInformarProximoPaso/ModalInformarProximoPaso';


class ContabilizadorRecontabilizador extends PureComponent {
    
    constructor(props) {
        super(props);
    }

    componentDidMount() {
           this.props.actions.primeraCargaContabilizadorRecontabilizador(this.props.currentScope,this.props.executionContext,this.props.data.inputsContabilizadorRecontabilizador.inputFechaContabilidadOriginal);
    }

    componentWillUnmount() {
        this.props.actions.resetState();
    }

    render() {
        const { actions, data } = this.props;

        const registroSeleccionado = data.datosCombo.find((reg) => reg.TrazaEjecucion == data.idRegistro);

        const error = {
            message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
            linkMessage: "Volver a mi pagina de inicio"
        };

        const errorPermiso = <GenericErrorScreen data={error} />;

        const componente = data.permisosUsuario.Ejecucion ?
                                <div className="ContabilizadorRecontabilizador__contenedor">
                                    <SeccionSuperior 
                                        validarEjecucionProceso={actions.validarEjecucionProceso}
                                        refrescarDatosPantalla={actions.refrescarDatosPantalla}

                                        data={data}
                                        seleccionarRadioButtonContabilizador={actions.seleccionarRadioButtonContabilizador}
                                        seEjecutoTotalidadProcesos={data.barraAvance && data.barraAvance.length > 0 && data.barraAvance[0].CantidadProcesosEjecutados == data.barraAvance[0].CantidadProcesosTotales}
                                    />

                                    {/* 0 - "Contabilizador" / 1 - "Re-contabilizador" */}
                                    {data.radioButtonsContabilizador.contabilizacion == 1 ?
                                        <SeccionRecontabilizacion
                                            guardarQuitarModeloSeleccionado={actions.guardarQuitarModeloSeleccionadoContabilizadorRecontabilizador}
                                            validarInputFecha={actions.validarInputFecha}
                                            mostrarOcultarModalContabilizadorRecontabilizador={actions.mostrarOcultarModalContabilizadorRecontabilizador}
                                            ocultarBotonVerMas={actions.ocultarBotonVerMas}

                                            errorValidacion={data.inputsContabilizadorRecontabilizador.errorValidacion}
                                            esPrimerPaso = {data.esPrimerPaso}
                                            fechaInput={data.inputsContabilizadorRecontabilizador.inputFechaContabilidadOriginal}
                                            habilitarEjecucionReconta={data.habilitarEjecucionReconta}
                                            hayProcesosEnEjecucion={data.hayProcesosEnEjecucion}
                                            modelosContablesSeleccionados={data.inputsContabilizadorRecontabilizador.modalSeleccionModelos.modelosContablesSeleccionados}
                                            mostrarVerMas={data.mostrarVerMas}
                                            todosModelosSeleccionados={data.checksContabilizador.modalSeleccionModelos.checkTodosModelos}                                            
                                        />
                                    :
                                        null
                                    }

                                    {/* Si se deshabilitan los componentes para la recontabilidad, eso quiere decir que la fecha seleccionada en el datepicker no se relaciona con ninguna contabilidad hecha, 
                                    por ese motivo se agrega un mensaje que informe esto */}
                                    {!data.habilitarEjecucionReconta && !data.ejecucionLoteIniciada &&
                                        <div className="genericLabel warningMessage">En la fecha seleccionada no se realizó ninguna ejecución del procesamiento de contabilidad, por lo que no existen asientos a ser regenerados para este día. Por favor elija otra fecha a re-contabilizar.</div>
                                    }
                                    
                                    {!data.ejecucionLoteIniciada && data.hayProcesosEnEjecucion ?
                                        <div className="genericLabel warningMessage">Actualmente existe en curso un procesamiento contable. Una vez finalizado el mismo, se habilitará nuevamente la interactividad de la pantalla.</div>
                                    :
                                        null
                                    }

                                    {data.ejecucionLoteIniciada ?
                                        <div className="genericLabel warningMessage warningMessageWithSpinner"> Se está ejecutando un lote de procesos contables actualmente… </div>
                                    :
                                        null
                                    }
                                    
                                    <div className="AsientosContables__lineaDivisoria ContabilizadorRecontabilizador__lineaDivisoria"></div>
                                    
                                    <SeccionProcesos
                                        cambiarValorCombo={actions.cambiarValorCombo}
                                        desplegarProcesos={actions.desplegarProcesos}
                                        mostrarOcultarModalContabilizadorRecontabilizador={actions.mostrarOcultarModalContabilizadorRecontabilizador}
                                        setearProximoPaso={actions.setearProximoPaso}
                                        cargarRegistrosDatosEjecucion={actions.cargarRegistrosDatosEjecucion}
                                        barraAvance={data.barraAvance}
                                        comboProceso={data.combosContabilizador.comboProceso}
                                        datosCombo={data.datosCombo}
                                        estaDesplegado={data.estaDesplegado}
                                        habilitarEjecucionReconta={data.habilitarEjecucionReconta}
                                        hayProcesosEnEjecucion={data.hayProcesosEnEjecucion}
                                        radioButtonsContabilizador={data.radioButtonsContabilizador}
                                    />

                                    {data.modalProceso ?
                                        <ModalProceso 
                                            mostrarOcultarModalContabilizadorRecontabilizador={actions.mostrarOcultarModalContabilizadorRecontabilizador}
                                            mostrarOcultarModalProceso={actions.mostrarOcultarModalProceso}
                                            validarEjecucionProceso={actions.validarEjecucionProceso}                                   
                                            descargarExcel={actions.descargarExcel}
                                            registroSeleccionado = {registroSeleccionado}
                                            registroEjecucionCabecera={data.registroEjecucionCabecera}
                                            datosCombo={data.datosCombo}
                                            esContabilizacion={data.radioButtonsContabilizador.contabilizacion == 0}
                                            hayProcesosEnEjecucion={data.hayProcesosEnEjecucion}
                                            idRegistro = {data.idRegistro}
                                            registroEjecucionDetalle={data.registroEjecucionDetalle}
                                        />
                                    :
                                        null
                                    }

                                    {data.modalConfirmacionEjecucion ?	
                                        <ModalConfirmacionEjecucion 	
                                            validarEjecucionProceso={actions.validarEjecucionProceso}	
                                            mostrarOcultarModalContabilizadorRecontabilizador={actions.mostrarOcultarModalContabilizadorRecontabilizador}	
                                            ejecucionIndividual={actions.ejecucionIndividual}	
                                            ejecucionLoteContabilidad={actions.ejecucionLoteContabilidad}	
                                            datosCombo={data.datosCombo}
                                            combosContabilizador={data.combosContabilizador}
                                            confirmaEjecucion={data.confirmaEjecucion}	
                                            esEjecucionGeneral = {data.esEjecucionGeneral}
                                            data={data}	
                                            nombreProceso={data.nombreProceso}
                                            tipoEjecucion={data.tipoEjecucion}	
                                        />
                                    :	
                                        null
                                    }

                                    {data.modalInformarProximoPaso ?
                                        <ModalInformarProximoPaso 
                                            mostrarOcultarModalContabilizadorRecontabilizador={actions.mostrarOcultarModalContabilizadorRecontabilizador}

                                            barraAvance={data.barraAvance}
                                        />
                                    :
                                        null
                                    }
                                    
                                    {data.modalSeleccionModelos ?
                                        <ModalSeleccionModelos
                                            buscarModelosContables={actions.buscarModelosContables}
                                            cambiarCheckContabilizadorRecontabilizador={actions.cambiarCheckContabilizadorRecontabilizador}
                                            guardarQuitarModeloSeleccionado={actions.guardarQuitarModeloSeleccionadoContabilizadorRecontabilizador}
                                            mostrarOcultarModalContabilizadorRecontabilizador={actions.mostrarOcultarModalContabilizadorRecontabilizador}

                                            checkTodosModelos={data.checksContabilizador.modalSeleccionModelos.checkTodosModelos}
                                            inputBuscadorModelos={data.inputsContabilizadorRecontabilizador.modalSeleccionModelos.inputBuscadorModelos}
                                            modelosContablesFiltrados={data.inputsContabilizadorRecontabilizador.modalSeleccionModelos.modelosContablesFiltrados}
                                            modelosContablesSeleccionados={data.inputsContabilizadorRecontabilizador.modalSeleccionModelos.modelosContablesSeleccionados}
                                        />
                                    :
                                        null
                                    }

                                </div>
                            :
                                errorPermiso

        return (
            <div className="ContabilizadorRecontabilizador__contenedor">
                {data.mostrarSpinner ?
                    <div id="loading" className="loading" />
                :
                    null
                }
                
                {componente}
            </div>
        );

    }
}

export default ContabilizadorRecontabilizador;